import { useEffect } from 'react';

/**
 * Custom hook to set the page title and meta description dynamically
 * @param title - The page-specific title (will be appended with company name)
 * @param description - The page-specific meta description (optional)
 * @param includeCompanyName - Whether to include company name in title (default: true)
 */
export const usePageTitle = (
  title: string,
  description?: string,
  includeCompanyName: boolean = true
) => {
  useEffect(() => {
    const companyName = '佛山市信力凯窑炉技术有限公司';
    const defaultDescription = '佛山市信力凯窑炉技术有限公司 - 专业的窑炉技术制造商';
    const fullTitle = includeCompanyName ? `${title} - ${companyName}` : title;

    // Set page title
    document.title = fullTitle;

    // Set meta description if provided
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', description);
    }

    // Cleanup: reset to default when component unmounts
    return () => {
      document.title = companyName;
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', defaultDescription);
      }
    };
  }, [title, description, includeCompanyName]);
};

export default usePageTitle;
